import React, { useEffect, useState } from "react";
import { Box, Typography, TextField } from "@mui/material";

interface DateRangePickerProps {
  bookingDates: { startDate: string; endDate: string };
  handleStartDateChange: (date: string) => void;
  handleEndDateChange: (date: string) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  bookingDates,
  handleStartDateChange,
  handleEndDateChange,
}) => {
  const [startDate, setStartDate] = useState(bookingDates.startDate);
  const [endDate, setEndDate] = useState(bookingDates.endDate);

  useEffect(() => {
    setStartDate(bookingDates.startDate);
    setEndDate(bookingDates.endDate);
  }, [bookingDates]);

  const handleStartDateSelect = (date: string) => {
    setStartDate(date);
    handleStartDateChange(date);
    // Reset end date if the new start date is after the current end date
    if (date && endDate && new Date(date) > new Date(endDate)) {
      setEndDate("");
      handleEndDateChange("");
    }
  };

  const handleEndDateSelect = (date: string) => {
    if (date && startDate && new Date(date) < new Date(startDate)) {
      // Prevent setting end date if it is before the start date
      return;
    }
    setEndDate(date);
    handleEndDateChange(date);
  };

  return (
    <Box>
      <Box mb={2}>
        <Typography>Da</Typography>
        <TextField
          type="date"
          value={startDate || ""}
          onChange={(e) => handleStartDateSelect(e.target.value)}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      <Box>
        <Typography>A</Typography>
        <TextField
          type="date"
          value={endDate || ""}
          onChange={(e) => handleEndDateSelect(e.target.value)}
          fullWidth
          InputProps={{
            inputProps: {
              min: startDate || "", // Set min date to startDate
            },
          }}
          InputLabelProps={{
            shrink: true,
          }}
          // Disable end date field if no start date is selected
          disabled={!startDate}
        />
      </Box>
    </Box>
  );
};

export default DateRangePicker;
